export default "__VITE_ASSET__BGon5Dvx__"